import dayjs from '../../../../shared/services/dayjs.js';
import { Egfz } from '../../../../shared/services/Egfz.js';
import { Roles } from '../../../../../domain/konstanten/Roles.js';
import { schichtenService } from '../services/SchichtenService.js';
import { secureHTML } from '../util.js';
import { erstelleZeitblockTabelle } from '../zeitblock.js';

// Relevante HTML Elemente auf die oft zugegriffen wird
const schichtDivTemplate = document.querySelector('[data-schicht-template]');

/**
 * Wählt eine Vorlage aus der Sidebar aus und markiert diese.
 * Bei erneuten Klick auf die selbe wird die Auswahl aufgehoben.
 * @param {string} vorlageID die ausgewählte VorlagenID
 */
function changeVorlageActive(vorlageID, event) {
	// Alle Markierungen aufheben...
	const vorlagenListe = document.getElementById('vorlagen-liste');
	[...vorlagenListe.querySelectorAll('.vorlage-liste-item-active')].forEach((vl) => vl.classList.remove('vorlage-liste-item-active'));
	// Input mit altem Input vergleichen, ggfs abwählen bei erneuten Klick auf die gleiche Vorlage.
	const vorlageSelect = document.getElementById('vorlage-tb-select');
	// Im Select Event ist vorlageID und select.value immer gleich, hier müssen wir unterscheiden zwischen Select und Sidebar...
	// ... und bei Klick auf Edit Vorlage nicht abwählen, da sonst der Vorlagen Editor keine Vorlage erhält
	if ((vorlageID == vorlageSelect.value && event.type !== 'change' && event.target.tagName !== 'I')) {
        vorlageSelect.value = '';
        return;
    }
	// Wenn es sich um eine andere Vorlage handelt, markieren wir diese.
	if (vorlageID != '') {
		vorlageSelect.value = vorlageID;
		const vorlage = vorlagenListe.querySelector(`[aria-label="${vorlageID}"]`);
		vorlage.classList.add('vorlage-liste-item-active');
	}
}

function erstelleVorlagenButtonsSidebar(vorlagen) {
	const vorlagenListe = document.getElementById('vorlagen-liste');
	vorlagenListe.innerHTML = '';
	const bereich = document.getElementById('bereich-select').selectedOptions[0].innerText;
	document.getElementById('vorlagen-liste-bereich').innerText = bereich;
	let egfzOptions = [
		{ EgfzID: Egfz.Krank, Bezeichnung: 'Krank', Titel: 'Krank' },
		{ EgfzID: Egfz.UnentschuldigtKrank, Bezeichnung: 'unent. krank', Titel: 'unentschuldigt Krank' },
		{ EgfzID: Egfz.KindKrank, Bezeichnung: 'Kind krank', Titel: 'kind Krank' },
		{ EgfzID: Egfz.Schule, Bezeichnung: 'Schule', Titel: 'Schule' },
		{ EgfzID: Egfz.GZAbbau, Bezeichnung: 'GZ-', Titel: 'Gutzeit Abbau' },
		{ EgfzID: Egfz.UnbezahltFrei, Bezeichnung: 'Frei', Titel: 'unbez. frei' },
		{ EgfzID: Egfz.Feiertag, Bezeichnung: 'Feiertag frei', Titel: 'Feiertag' }
	];
	// Nur Dienstplaner Rolle darf keine Urlaube anlegen, alle anderen Rollen schon
	if (
		window.myVars.UserRoles.includes(Roles.Sachbearbeiter) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget) ||
		window.myVars.UserRoles.includes(Roles.Zeitenpfleger)
 	) {
		egfzOptions.push({
		EgfzID: Egfz.Urlaub,
		Bezeichnung: 'Urlaub',
		Titel: 'Urlaub',
		});
 	}
	egfzOptions.forEach((egfzKrank) => {
		const schichtElement = schichtDivTemplate.content.cloneNode(true).children[0];
		const schichtTitel = schichtElement.querySelector('[schicht-titel]');
		schichtElement.classList.add('egfz-schicht');
		schichtElement.style.cursor = 'pointer';
		schichtElement.setAttribute('aria-label', egfzKrank.EgfzID);
		schichtTitel.innerText = egfzKrank.Bezeichnung;
		schichtElement.title = egfzKrank.Titel;
		schichtElement.querySelector('.span-div').style.display = 'none';
		schichtElement.addEventListener('click', (event) => changeVorlageActive(egfzKrank.EgfzID, event));
		vorlagenListe.appendChild(schichtElement);
	});
	vorlagen.forEach((vorlage) => {
		const schichtElement = schichtDivTemplate.content.cloneNode(true).children[0];
		// --schicht-farbe statt direktem border-color: dienstplan.css leitet daraus per color-mix()
		// zusätzlich einen hellen Hintergrundton ab (Rand in voller Farbe, Fläche abgetönt).
		if (vorlage.SchichtFarbe) {
			schichtElement.style.setProperty('--schicht-farbe', vorlage.SchichtFarbe);
		}
		const schichtTitel = schichtElement.querySelector('[schicht-titel]');
		const schichtBeschreibung = schichtElement.querySelector('[schicht-beschreibung]');
		const titel = secureHTML(vorlage.Titel);
		let beschreibung = `${secureHTML(dayjs(vorlage.SchichtVon).tz().format('HH:mm'))} - ${secureHTML(dayjs(vorlage.SchichtBis).tz().format('HH:mm'))}`;
		if (!vorlage.OffenesEnde && vorlage.OffenerBeginn) {
			beschreibung = `bis ${secureHTML(dayjs(vorlage.SchichtBis).tz().format('HH:mm'))}`;
		}
		if (vorlage.OffenesEnde && !vorlage.OffenerBeginn) {
			beschreibung = `ab ${secureHTML(dayjs(vorlage.SchichtVon).tz().format('HH:mm'))}`;
		}
		if (vorlage.OffenesEnde && vorlage.OffenerBeginn) {
			beschreibung = '';
		}
		schichtTitel.innerText = titel;
		schichtBeschreibung.innerText = beschreibung;
		const vorlageID = vorlage._id;
		schichtElement.setAttribute('aria-label', vorlageID);
		schichtElement.classList.add('vorlagen-liste-item');
		vorlagenListe.appendChild(schichtElement);
		schichtElement.addEventListener('click', (event) => changeVorlageActive(vorlageID, event));
		schichtElement.querySelector('[span-edit]').addEventListener('click', (event) => {
			// Nicht an schichtElement weiterblubbern: changeVorlageActive würde sonst je nach exaktem
			// Klickpunkt (Icon-Glyph vs. umgebendes Span-Polster) #vorlage-tb-select auf '' zurücksetzen,
			// während erstelleSchichtVorlagenInputFeld (unten) noch asynchron läuft und diesen Wert am
			// Ende erneut ausliest, um die Vorlage vorzuladen — dadurch würde die Vorlage nicht selektiert.
			event.stopPropagation();
			window.tb.erstelleSchichtVorlagenInputFeld(vorlageID);
		});
		schichtElement.querySelector('[span-remove]').style.display = 'none';
	});
}

// Custom comparison function
function customCompareBoolean(a, b) {
	if (a.OffenerBeginn === true && a.OffenesEnde === true && (b.OffenerBeginn !== true || b.OffenesEnde !== true)) {
	  return 1; // a comes after b
	} else if (b.OffenerBeginn === true && b.OffenesEnde === true && (a.OffenerBeginn !== true || a.OffenesEnde !== true)) {
	  return -1; // b comes after a
	} else {
	  return 0; // No change in order
	}
  }

function erstelleVorlagenOptgroup(schichten) {
	const optgroupVorlage = document.createElement('optgroup');
	optgroupVorlage.label = 'Schichtvorlagen';
	schichten.forEach((schicht) => {
		const newOption = document.createElement('option');
		newOption.id = schicht._id;
		newOption.setAttribute('value', schicht._id);
		newOption.innerText = `${schicht.Titel}, `
			+ `${dayjs(schicht.SchichtVon).tz().format('HH:mm')} - ${dayjs(schicht.SchichtBis).tz().format('HH:mm')}`;
		// offenes Ende
		if (schicht.OffenesEnde && !schicht.OffenerBeginn) {
			newOption.innerText = `${schicht.Titel}, `
			+ `ab ${dayjs(schicht.SchichtVon).tz().format('HH:mm')}`;
		}
		// offener Beginn
		if (!schicht.OffenesEnde && schicht.OffenerBeginn) {
			newOption.innerText = `${schicht.Titel}, `
			+ `bis ${dayjs(schicht.SchichtBis).tz().format('HH:mm')}`;
		}
		// offener Beginn und Ende
		if (schicht.OffenesEnde && schicht.OffenerBeginn) {
			newOption.innerText = `${schicht.Titel}`;
		}
		optgroupVorlage.appendChild(newOption);
	});
	return optgroupVorlage;
}

function erstelleEGFZOptgroup() {
	const optgroupEGFZ = document.createElement('optgroup');
	optgroupEGFZ.label = 'Krank einfügen';
	let egfzOptions = [
		{ EgfzID: Egfz.Krank, Bezeichnung: 'Krank' },
		{ EgfzID: Egfz.UnentschuldigtKrank, Bezeichnung: 'unentschuldigt krank' },
		{ EgfzID: Egfz.KindKrank, Bezeichnung: 'Kind krank' },
		{ EgfzID: Egfz.Schule, Bezeichnung: 'Schule' },
		{ EgfzID: Egfz.GZAbbau, Bezeichnung: 'GZ-' },
		{ EgfzID: Egfz.UnbezahltFrei, Bezeichnung: 'Frei' },
		{ EgfzID: Egfz.Feiertag, Bezeichnung: 'Feiertag frei' }
	];
	// Nur Dienstplaner Rolle darf keine Urlaube anlegen, alle anderen Rollen schon
	if (
		window.myVars.UserRoles.includes(Roles.Sachbearbeiter) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget) ||
		window.myVars.UserRoles.includes(Roles.Zeitenpfleger)
 	) {
		egfzOptions.push({ EgfzID: Egfz.Urlaub, Bezeichnung: 'Urlaub' });
	}
	egfzOptions.forEach((egfzKrank) => {
		const newOption = document.createElement('option');
		newOption.setAttribute('value', egfzKrank.EgfzID);
		newOption.innerText = egfzKrank.Bezeichnung;
		optgroupEGFZ.appendChild(newOption);
	});
	return optgroupEGFZ;
}

/**
 * Erstellt ein Select Feld mit den Schichtvorlagen
 * @param {boolean} isToolbar Flag ob das Select für die Toolbar oder Schicht Editor erstellt werden soll
 * @param {Number} isEditSchicht Flag ob das Select im Schicht Editiermodus ist
 */
async function erstelleSchichtVorlageSelect(isToolbar = false, isEditSchicht = false) {
	// Reset falls schon da gewesen, z.B. beim Bereichwechsel oder Speichern von neuen Schichtvorlagen
	if (document.getElementById('input-vorlage') !== null) {
		document.getElementById('input-vorlage').remove();
	}
	const bereichID = document.getElementById('bereich-select').value;
	const vorlagen = await schichtenService.holeSchichtVorlagen(bereichID);
	vorlagen.sort((a, b) => a.Titel.localeCompare(b.Titel)); // alphabetisch sortieren
	vorlagen.sort((a, b) => new Date(a.SchichtVon) - new Date(b.SchichtVon)); // nach Schichtbeginn sortieren
	vorlagen.sort((a, b) => Number(a.OffenerBeginn) - Number(b.OffenerBeginn)); // Offener Beginn ans Ende der Liste sortieren
	vorlagen.sort((a, b) => customCompareBoolean(a, b)); // Schichten mit offenen Beginn und Ende ans Ende der Liste sortieren
	const select = document.createElement('select');
	select.id = 'input-vorlage';
	select.className = 'inp';
	// Leere Option anbieten...
	const emptyOption = document.createElement('option');
	emptyOption.setAttribute('value', '');
	emptyOption.innerText = isToolbar || isEditSchicht ? 'Schichtvorlage wählen' : 'Neue Schichtvorlage';
	select.append(emptyOption);
	// Schichtvorlagen Optionen anbieten...
	const optgroupVorlage = erstelleVorlagenOptgroup(vorlagen);
	select.appendChild(optgroupVorlage);
	// Weitere EGFZ Optionen anbieten in der Toolbar...
	if (isToolbar) {
		const optgroupEGFZ = erstelleEGFZOptgroup();
		select.appendChild(optgroupEGFZ);
		select.addEventListener('change', (event) => changeVorlageActive(select.value, event));
	}

	// Wir brauchen den EventListener nicht für die Toolbar
	if (!isToolbar) {
		select.addEventListener('change', () => {
			// Schicht Werte laden (nur im Vorlage-Editor erreichbar, siehe "Vorhandene Vorlage laden")
			const auswahl = vorlagen.find((s) => s._id === select.value);
			if (auswahl !== undefined) {
				// Übernehmen der Attribute aus der ausgewählten Vorlage...
				const ganztagsCheck = document.getElementById('input-schicht-ganztags');
				const offenesEndeCheck = document.getElementById('input-schicht-offenes-ende');
				const offenerBeginnCheck = document.getElementById('input-schicht-offener-beginn');
				ganztagsCheck.checked = !!auswahl.Ganztags;
				offenesEndeCheck.checked = !!auswahl.OffenesEnde;
				offenerBeginnCheck.checked = !!auswahl.OffenerBeginn;
				// Segmented Control passend nachziehen (gleiche Zuordnung wie schichtEditor.js:initArtSegment)
				const seg = document.getElementById('input-art-seg');
				let art = 'fest';
				if (ganztagsCheck.checked) art = 'ganztags';
				else if (offenerBeginnCheck.checked && offenesEndeCheck.checked) art = 'ganztags';
				else if (offenerBeginnCheck.checked) art = 'offenerBeginn';
				else if (offenesEndeCheck.checked) art = 'offenesEnde';
				seg?.querySelectorAll('.o').forEach((o) => o.classList.toggle('on', o.dataset.art === art));

				const farbInput = document.getElementById('input-schicht-farbe');
				farbInput.value = auswahl.SchichtFarbe ? auswahl.SchichtFarbe : '#0071bd';
				farbInput.dispatchEvent(new Event('input'));
				document.getElementById('input-schicht-notiz').value = auswahl.SchichtNotiz ? auswahl.SchichtNotiz : '';
				document.getElementById('input-vorlage-titel').value = auswahl.Titel;
				erstelleZeitblockTabelle(auswahl, 0);
			}
		});
	}

	if (isToolbar) {
		// wir brauchen auch die buttons für die übersicht
		erstelleVorlagenButtonsSidebar(vorlagen);
	}
	return select;
}

/**
 * Baut das Schichtvorlagen-Select in der Toolbar neu auf (z.B. bei Bereichwechsel oder nach dem
 * Speichern einer neuen Vorlage).
 */
async function erstelleToolbarVorlagenSelect() {
	const oldSelect = document.getElementById('vorlage-tb-select');
	if (oldSelect) {
		oldSelect.remove();
	}
	const vorlageSelect = await erstelleSchichtVorlageSelect(true);
	vorlageSelect.id = 'vorlage-tb-select';
	// .inp (Dialog-Style, 40px) käme mit .tbtn (Toolbar-Style, 36px) in Konflikt — für die Toolbar
	// komplett ersetzen statt addieren.
	vorlageSelect.className = 'tbtn kw-select';
	// Steht in der Toolbar vor "Woche kopieren" (der Vorlagen-Editor-Button sitzt in der Sidebar).
	document.querySelector('#kopieren-tb-div').insertAdjacentElement('beforebegin', vorlageSelect);
}

export { erstelleSchichtVorlageSelect, erstelleToolbarVorlagenSelect };
